import {
  Component,
  ChangeDetectionStrategy,
  inject,
  signal,
} from '@angular/core';

import { IsoWeekService } from '@app/core/services/isoWeek.service';
import { NavService } from '@app/core/services/nav.service';
import { INavigationType } from '../../interfaces/navigation.interface';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationComponent {
  // dependencies
  navService = inject(NavService);
  isoWeekService = inject(IsoWeekService);

  navigationConfig = signal<INavigationType[]>(
    this.navService.getMainNavigation(),
  );

  constructor() {}
}
